import React from 'react';

const platformConfig = {
  instagram: { label: 'Instagram', color: '#E4405F', letter: 'I' },
  facebook: { label: 'Facebook', color: '#1877F2', letter: 'F' },
  twitter: { label: 'X / Twitter', color: '#1DA1F2', letter: 'X' },
  linkedin: { label: 'LinkedIn', color: '#0A66C2', letter: 'L' },
  tiktok: { label: 'TikTok', color: '#000000', letter: 'T' },
  youtube: { label: 'YouTube', color: '#FF0000', letter: 'Y' },
  threads: { label: 'Threads', color: '#000000', letter: 'T' },
  telegram: { label: 'Telegram', color: '#26A5E4', letter: 'Te' },
};

export function PlatformIcon({ platform, size = 'sm', showLabel = false, className = '' }) {
  const config = platformConfig[platform?.toLowerCase()] || { label: platform, color: '#6B7280', letter: '?' };
  const sizeClasses = {
    xs: 'w-5 h-5 text-[10px]',
    sm: 'w-7 h-7 text-xs',
    md: 'w-9 h-9 text-sm',
    lg: 'w-11 h-11 text-base',
  };

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`}>
      <div
        className={`${sizeClasses[size]} rounded-md flex items-center justify-center font-bold text-white shrink-0`}
        style={{ backgroundColor: config.color }}
        title={config.label}
      >
        {config.letter}
      </div>
      {showLabel && <span className="text-sm font-medium">{config.label}</span>}
    </div>
  );
}

export function PlatformPill({ platform, className = '' }) {
  const config = platformConfig[platform?.toLowerCase()] || { label: platform, color: '#6B7280' };
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium text-white ${className}`}
      style={{ backgroundColor: config.color }}
    >
      {config.label}
    </span>
  );
}

export const PLATFORMS = Object.entries(platformConfig).map(([key, value]) => ({
  value: key,
  label: value.label,
  color: value.color,
}));
